// This file is generated by [oats][0] and should not be edited by hand.
//
// [0]: https://github.com/influxdata/oats

export interface Token {
  token?: string
}

export interface Error {
  readonly code:
    | 'internal error'
    | 'not found'
    | 'conflict'
    | 'invalid'
    | 'unprocessable entity'
    | 'empty value'
    | 'unavailable'
    | 'forbidden'
    | 'too many requests'
    | 'unauthorized'
    | 'method not allowed'
    | 'request too large'
    | 'unsupported media type'
  readonly message?: string
  readonly op?: string
  readonly err?: string
}

interface RequestOptions {
  signal?: AbortSignal
}

export type RequestHandler = (
  url: string,
  query: string,
  init: RequestInit
) => {url: string; query: string; init: RequestInit}
export type ResponseHandler = (
  status: number,
  headers: Headers,
  data: any
) => {status: number; headers: Headers; data: any}

const RequestContext = function(
  requestHandler: RequestHandler,
  responseHandler: ResponseHandler
) {
  this.requestHandler = requestHandler
  this.responseHandler = responseHandler
}

RequestContext.prototype.request = async function(
  method: string,
  url: string,
  params: any = {},
  options: RequestOptions = {}
): Promise<any> {
  const requestHeaders = new Headers(params.headers)
  const contentType = requestHeaders.get('Content-Type') || ''

  if (params.auth) {
    const credentials = btoa(`${params.auth.username}:${params.auth.password}`)

    requestHeaders.append('Authorization', `Basic ${credentials}`)
  }

  const body =
    params.data && contentType.includes('json')
      ? JSON.stringify(params.data)
      : params.data

  const query = params.query ? `?${new URLSearchParams(params.query)}` : ''

  const {
    url: middlewareUrl,
    query: middlewareQuery,
    init,
  } = this.requestHandler(url, query, {
    method,
    body,
    credentials: 'same-origin',
    signal: options.signal,
    headers: requestHeaders,
  })

  const response = await fetch(`${middlewareUrl}${middlewareQuery}`, init)

  const {status, headers} = response
  const responseContentType = headers.get('Content-Type') || ''

  let data

  if (responseContentType.includes('json')) {
    data = await response.json()
  } else if (responseContentType.includes('octet-stream')) {
    data = await response.blob()
  } else {
    data = await response.text()
  }

  return this.responseHandler(status, headers, data)
}

RequestContext.prototype.setRequestHandler = function(
  requestHandler: RequestHandler
) {
  this.requestHandler = requestHandler
}

RequestContext.prototype.setResponseHandler = function(
  responseHandler: ResponseHandler
) {
  this.responseHandler = responseHandler
}

const rc = new RequestContext(
  (url, query, init) => {
    return {url, query, init}
  },
  (status, headers, data) => {
    return {status, headers, data}
  }
)
const request = rc.request.bind(rc)
const setRequestHandler = rc.setRequestHandler.bind(rc)
const setResponseHandler = rc.setResponseHandler.bind(rc)

export {request, setRequestHandler, setResponseHandler}

export interface GetUiproxyMapTokenParams {}

type GetUiproxyMapTokenResult =
  | GetUiproxyMapTokenOKResult
  | GetUiproxyMapTokenUnauthorizedResult
  | GetUiproxyMapTokenInternalServerErrorResult
  | GetUiproxyMapTokenDefaultResult

interface GetUiproxyMapTokenOKResult {
  status: 200
  headers: Headers
  data: Token
}

interface GetUiproxyMapTokenUnauthorizedResult {
  status: 401
  headers: Headers
  data: Error
}

interface GetUiproxyMapTokenInternalServerErrorResult {
  status: 500
  headers: Headers
  data: Error
}

interface GetUiproxyMapTokenDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getUiproxyMapToken = (
  params: GetUiproxyMapTokenParams,
  options: RequestOptions = {}
): Promise<GetUiproxyMapTokenResult> =>
  request('GET', '/api/v2private/uiproxy/mapToken', params, options) as Promise<
    GetUiproxyMapTokenResult
  >

export interface PostUiproxySfdcSupportParams {
  data: {
    description?: string
    email?: string
    severity?: string
    subject?: string
  }
}

type PostUiproxySfdcSupportResult =
  | PostUiproxySfdcSupportNoContentResult
  | PostUiproxySfdcSupportUnauthorizedResult
  | PostUiproxySfdcSupportInternalServerErrorResult

interface PostUiproxySfdcSupportNoContentResult {
  status: 204
  headers: Headers
  data: any
}

interface PostUiproxySfdcSupportUnauthorizedResult {
  status: 401
  headers: Headers
  data: Error
}

interface PostUiproxySfdcSupportInternalServerErrorResult {
  status: 500
  headers: Headers
  data: Error
}

export const postUiproxySfdcSupport = (
  params: PostUiproxySfdcSupportParams,
  options: RequestOptions = {}
): Promise<PostUiproxySfdcSupportResult> =>
  request(
    'POST',
    '/api/v2private/uiproxy/sfdc-support',
    {...params, headers: {'Content-Type': 'application/json'}},
    options
  ) as Promise<PostUiproxySfdcSupportResult>
